import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { logger } from 'modules/core';

export let awsRum: AwsRum | null = null;

export const awsRumService = {
    logHomeItemClick: (itemId: string): void => {
        if (awsRum) {
            try {
                awsRum.recordEvent('home_item_clicked', {
                    data: {
                        home_item_id: itemId,
                        click_count: 1
                    }
                });
            } catch (error) {
                logger.error('Failed to record RUM event:', error);
            }
        }
    }
};

export function initializeRUM(): void {
    try {
        const applicationId = process.env.REACT_APP_RUM_APPLICATION_ID as string;
        const guestRoleArn = process.env.REACT_APP_RUM_GUEST_ROLE_ARN as string;
        const identityPoolId = process.env.REACT_APP_RUM_IDENTITY_POOL_ID as string;
        const endpoint = process.env.REACT_APP_RUM_ENDPOINT as string;
        const applicationVersion = process.env.REACT_APP_RUM_APPLICATION_VERSION as string;
        const applicationRegion = process.env.REACT_APP_RUM_APPLICATION_REGION as string;

        const rumConfig: AwsRumConfig = {
            sessionSampleRate: 1,
            guestRoleArn: guestRoleArn,
            identityPoolId: identityPoolId,
            endpoint: endpoint,
            telemetries: ['errors', 'performance', 'http'],
            allowCookies: true,
            enableXRay: true
        };

        awsRum = new AwsRum(applicationId, applicationVersion, applicationRegion, rumConfig);
    } catch (error) {
        logger.error('Failed to initialize RUM client:', error);
    }
}
